import script from "./MeterActualMark.vue?vue&type=script&setup=true&lang=js"
export * from "./MeterActualMark.vue?vue&type=script&setup=true&lang=js"

import "./MeterActualMark.vue?vue&type=style&index=0&id=4c2b75e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c2b75e8"]])

export default __exports__